import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core"
import { Form, Formik } from "formik"
import PropTypes from "prop-types"
import { useContext, useState } from "react"
import { useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"
import * as Yup from "yup"
import CounterHeader from "~/components/Common/CounterHeader"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import serialize from "~/store/serialize"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CreateCategoryDialog = () => {
  const queryClient = useQueryClient()
  const classes = useStyles()
  const authContext = useContext(AppContext)
  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["createCategoryDialog"] || {}
  const { open = false } = thisDialog
  const openErrorSnackbar = useOpenErrorSnackbar()
  const history = useHistory()
  let title = thisDialog?.data?.title
  let subtitle = thisDialog?.data?.subtitle
  let createFuncMutation = thisDialog?.data?.create
  let refetch = thisDialog?.data?.refetch

  let type = thisDialog?.data?.type

  const [catName, setCatName] = useState("")

  const schema = Yup.object().shape({
    name: Yup.string()
      .required(`Please enter a ${type} name`)
      .max(50, "Name must be less than 50 characters"),
  })

  const handleClose = () => {
    setCatName("")
    closeDialog("createCategoryDialog", false)
  }

  const onSubmit = (values, actions) => {
    createFuncMutation.mutate(values, {
      onSuccess: (res) => {
        serialize("category", res.data).then((serializedData) => {
          queryClient.setQueryData("categories", (oldData) => {
            return [...oldData, serializedData]
          })
        })
        refetch()
        authContext.openSnackBar({
          message: `${
            type?.[0]?.toUpperCase() + type.substring(1) + " Created"
          }`,
        })
        history.push(`/categories/${res.data.id}`)
      },
      onError: (err) => {
        openErrorSnackbar(true, "There was an error creating this category")
      },
      onSettled: () => {
        handleClose()
      },
    })
  }

  return (
    <Dialog classes={{ paperWidthSm: classes.dialogMinHeight }} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Typography color="primary" variant="subtitle2">
          {subtitle}
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{ name: catName }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({ errors, touched, handleBlur, isSubmitting, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent className={classes.dialogContent}>
              <CounterHeader
                title={
                  type?.[0]?.toUpperCase() + type?.substring(1) + " " + "Name"
                }
                value={catName}
                max={50}
              />
              <TextField
                type="text"
                name="name"
                id="name"
                value={catName}
                onChange={(e) => {
                  setCatName(e.target.value)
                }}
                onBlur={handleBlur}
                helperText={
                  <span>
                    {catName.length > 0
                      ? catName.length > 0
                      : touched.name && errors.name
                        ? errors.name
                        : " "}
                  </span>
                }
                /* eslint-disable-next-line */
                autoFocus
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && e.target.value.length > 0) {
                    e.preventDefault()
                    onSubmit({
                      name: e.target.value,
                    })
                  }
                }}
                error={
                  catName.length > 0 ? true : !!(touched.name && errors.name)
                }
                variant="filled"
                size="small"
                fullWidth
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Box margin="16px">
                <Button
                  onClick={handleClose}
                  style={{ height: "40px", marginRight: "8px" }}
                >
                  Cancel
                </Button>
                <LoaderButton
                  type="submit"
                  // onClick={onSubmit}
                  classoverrides={{
                    wrapper: classes.button,
                    button: {
                      root: classes.buttonRoot,
                    },
                  }}
                  variant="contained"
                  color="secondary"
                  working={isSubmitting}
                  size="small"
                  onClick={(e) => {
                    e.preventDefault()
                    onSubmit({
                      name: catName,
                    })
                  }}
                >
                  add
                </LoaderButton>
              </Box>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

CreateCategoryDialog.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
}

export default CreateCategoryDialog
